import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCategorywiseRevenue } from "../../services/levelrevenue.services";

export const fetchCategorywiseRevenue = createAsyncThunk(
  "categorywiseRevenue/fetch",
  async (groupBy, { rejectWithValue }) => {
    try {
      const data = await getCategorywiseRevenue(groupBy);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const categorywiseRevenueSlice = createSlice({
  name: "categorywiseRevenue",
  initialState: {
    monthly: [],
    yearly: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategorywiseRevenue.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCategorywiseRevenue.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (action.meta.arg === "month") {
          state.monthly = action.payload.monthly_categorywise_revenue || [];
        } else if (action.meta.arg === "year") {
          state.yearly = action.payload.yearly_categorywise_revenue || [];
        }
      })
      .addCase(fetchCategorywiseRevenue.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default categorywiseRevenueSlice.reducer;
